import { apiGet, apiPost, apiPatch } from '@/app/api/core/http';
import { CONTACTS_PATHS } from './paths';

export const contactsApiAdapter = {
  createContact: (data) => apiPost(CONTACTS_PATHS.contacts, { data, is_protected: true }),
  getContacts: (params, cat, headers) => {
    const { clearParams, ...rest } = params;
    let preparedParams = {
      params: rest,
      clearParams,
      is_protected: true,
    };
    if (headers) {
      preparedParams.headers = headers.headers;
    }
    return apiGet(CONTACTS_PATHS.contacts + CONTACTS_PATHS.suffix, preparedParams);
  },
  getContactsDetails: (id, headers) => {
    if (headers) {
      return apiGet(`${CONTACTS_PATHS.contacts}/${id}`, {
        headers: headers,
        is_protected: true,
      });
    } else {
      return apiGet(`${CONTACTS_PATHS.contacts}/${id}`, { is_protected: true });
    }
  },
  getContactsStats: () => apiGet(CONTACTS_PATHS.stats),
  updateContact: async (id, data) => apiPatch(`${CONTACTS_PATHS.contacts}/${id}`, { data }),
  customerAddresses: {
    getList: (params) => apiGet(CONTACTS_PATHS.customerAddresses + CONTACTS_PATHS.suffix, { params }),
  },
};

export const contactsFilterAdapter = {
  getMediaResourceTypes: (params) => apiGet(CONTACTS_PATHS.mediaResourceTypes, params),
};
